import { render, staticRenderFns } from "./CommonLayoutHistoryTemplate.vue?vue&type=template&id=4bd03834&scoped=true&"
import script from "./CommonLayoutHistoryTemplate.vue?vue&type=script&lang=js&"
export * from "./CommonLayoutHistoryTemplate.vue?vue&type=script&lang=js&"
import style0 from "./CommonLayoutHistoryTemplate.vue?vue&type=style&index=0&id=4bd03834&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4bd03834",
  null
  
)

export default component.exports